const getSortedRegulaImages = (images: any[]): any[] => {
  return images
    .filter((item: any) => item.fieldName.includes('Document'))
    .sort(
      (a: any, b: any) =>
        a.pageIndex - b.pageIndex || a.containerType - b.containerType
    )
    .filter((item: any, index: number, self: any) => {
      return (
        index === self.findIndex((i: any) => i.pageIndex === item.pageIndex)
      )
    })
}

// const hasIdDocTypeLngSelection = (idDocType: IdDocType): boolean => {
//   switch (idDocType) {
//     // case IdDocType.ID_CARD:
//     //   return true
//     default:
//       return false
//   }
// }

// const getRegulaScenario = (
//   idDocType: IdDocType,
//   country?: string
// ): InternalScenarios => {
//   if (
//     hasIdDocTypeLngSelection(idDocType) &&
//     country &&
//     barcodeCountries.includes(country)
//   ) {
//     return InternalScenarios.BarcodeAndLocate
//   }

//   return InternalScenarios.MrzAndLocate
// }

// const getIdValidSince = (country: string): string | undefined => {
//   switch (country) {
//     case 'BO':
//       return 'November 2023'
//     case 'BF':
//       return '2017'
//     case 'CM':
//       return '2023'
//   }
// }

// const getValidIdCountries = (): any[] => {
//   const updatedCountries = countries.map((c) => {
//     const validSince = getIdValidSince(c.value)
//     if (validSince) {
//       return {
//         ...c,
//         label: `${c.label} (only if newer than ${validSince})`
//       }
//     }
//     return c
//   })

//   return updatedCountries.filter((c) => {
//     if (mrzCountries.includes(c.value) || barcodeCountries.includes(c.value)) {
//       return true
//     }

//     return false
//   })
// }

export {
  getSortedRegulaImages,
  // hasIdDocTypeLngSelection,
  // getRegulaScenario,
  // getValidIdCountries
}
